module.exports = __webpack_public_path__ + "static/media/image3.5c411f3f.jpg";